/* unplugin-vue-components disabled */import { render } from "./CollectUserPay.vue?vue&type=template&id=d85085d2&scoped=true"
import script from "./CollectUserPay.vue?vue&type=script&lang=js"
export * from "./CollectUserPay.vue?vue&type=script&lang=js"

import "./CollectUserPay.vue?vue&type=style&index=0&id=d85085d2&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d85085d2"]])

export default __exports__